import type { VariantProps } from 'class-variance-authority'

import { cva } from 'class-variance-authority'

export { default as Spinner } from './Spinner.vue'

// Size axis added 2026-07-19: KUICoreLoaderAnyway (the highest-usage KUI
// loader this replaces) exposes 2xs–lg from 8 to 96px and DEFAULTS to the
// 96px page loader, so a classless spinner stuck at 16px could not absorb
// its 95 usages. DS t-shirt scale: sm 16 (default — stock shadcn) · md 24 ·
// lg 48 · xl 96. KUI mapping at migration: 2xs/xs → sm · sm → md · md → lg ·
// lg → xl; odd sizes stay class-tunable (`class="size-8"`).
//
// Illustration spin (2026-07-22, revised): the branded record-style loader
// (KUICoreLoaderAnyway — used all over the product) is NOT a bespoke `vinyl`
// variant; it is the generic "spin an illustration" capability. Slot ANY
// content (typically `<Illustration src=".../anyway-record.webp">`) and the
// Spinner rotates it at the sized box; with no slot it renders the stock shadcn
// `Loader2Icon`. One mechanism, DS-consistent (compose, don't special-case).
export const spinnerVariants = cva('animate-spin', {
  variants: {
    size: {
      sm: 'size-4',
      md: 'size-6',
      lg: 'size-12',
      xl: 'size-24',
    },
  },
  defaultVariants: {
    size: 'sm',
  },
})
export type SpinnerVariants = VariantProps<typeof spinnerVariants>
